import {Component, Inject, Input, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {AuditLogVO} from '../../../generate/AuditLogVO';

@Component({
    selector: 'lib-audit-log-individual-section',
    templateUrl: './audit-log-individual-section.component.html',
    styleUrls: ['./audit-log-individual-section.component.scss'],
    standalone: false
})
export class AuditLogIndividualSectionComponent implements OnInit {
  descriptionVisible: boolean;

  @Input()
  auditLog: AuditLogVO;

  @Input()
  changeRequestId: string;

  @Input()
  tldName: string;

  subject: string[] = [];

  urlValue: string;

  linkType: string;

  constructor(private router: Router, @Inject('env') private environment) {
  }

  ngOnInit() {
    this.descriptionVisible = true;
    let auditlogSubject = this.auditLog.subject || '';
    if (auditlogSubject.indexOf("<") > -1) {
      let dynamicID = auditlogSubject.substr(auditlogSubject.indexOf("<"), auditlogSubject.indexOf(">") - auditlogSubject.indexOf("<") + 1);
      auditlogSubject = auditlogSubject.replace(dynamicID, "{{url}}");
      this.subject = auditlogSubject.split("{{url}}");
      const idWithType = dynamicID.split(":");
      this.linkType = idWithType[0].replace("<", "");
      this.urlValue = idWithType[1].replace(">", "");
    }


  }


  toggle() {
    this.descriptionVisible = !this.descriptionVisible;
  }

  navigateToTechCheckResultsDetails() {
    let urlPrefix = "";

    let interfaceType = this.environment.config.interfaceType;
    if (interfaceType === 'TLD_MANAGER') {
      urlPrefix = "user";
    } else if (interfaceType === 'STAFF') {
      urlPrefix = "admin";
    }

    this.router.navigate([`${urlPrefix}/request-details/${this.changeRequestId}/domain/${this.tldName}/tech-check/${this.urlValue}`], {
      state: {
        changeRequestID: this.changeRequestId,
        techCheckTestID: this.urlValue,
        domainName: this.tldName
      }
    });
  }


  private navigateToChangeRequestPage() {
    let urlPrefix = "";
    let interfaceType = this.environment.config.interfaceType;
    if (interfaceType === 'TLD_MANAGER') {
      urlPrefix = "/user";
    } else if (interfaceType === 'STAFF') {
      urlPrefix = "/admin";
    }
    this.router.navigate([urlPrefix + `/request-details/` + this.urlValue]);
  }

  navigate() {
    switch (this.linkType) {
      case 'test':
        this.navigateToTechCheckResultsDetails();
        break;
      case 'changerequest':
        this.navigateToChangeRequestPage();
        break;
    }
  }

}
